import React from 'react';
import { HuchaPosventaValues } from '../../../shared/models/hucha-values';
import {
	Container,
	ContainerPadding,
	TextAlignment,
	TokenTextAppearance,
	TokenTextColor,
	ContainerGutter,
	Text,
} from '@volkswagen-onehub/components-core';
import { BonoPosventaPdfLogo } from '../../assets/pdf-bono-posventa-logo';
import styled from 'styled-components';
import { PdfBonoPosventaCard } from './pdf-bono-posventa-card/pdf-bono-posventa-card';
import { COLOR_TOKEN } from '../../../../../../helpers/color-tokens';
import { BonoPosventaDisclaimerContent } from '../disclaimers/bono-disclaimer-content';
import { VouchersHelper } from '../../../../../../helpers/VouchersHelper';
import { StatusIndicator } from '../popup/popup-bono-posventa';

const UserDataContainer = styled(Container)`
	border-top: 0.75px solid #dfe4e8;
	border-bottom: 0.75px solid #dfe4e8;
`;

const RelativeContainer = styled.div`
	position: relative;
`;

const VouchersHuchaContainer = styled.div`
	position: absolute;
	bottom: -10%;
	left: 50%;
	transform: translateX(-50%);
	z-index: 2;
	width: max-content;
	padding: var(--size-dynamic0020) var(--size-dynamic0050);
	background-color: ${COLOR_TOKEN.button.primary.default};
	border: 1px solid ${COLOR_TOKEN.content.inverted};
	border-radius: 16px;
`;

export const PdfBonoPosventa = ({ huchaValues }: { huchaValues: HuchaPosventaValues | null }) => {
	if (!huchaValues) return null;

	return (
		<>
			<Container
				padding={{
					top: ContainerPadding.static400,
					bottom: ContainerPadding.static400,
				}}
				stretchContent
			>
				<BonoPosventaPdfLogo />
			</Container>

			<Container padding={ContainerPadding.dynamic0200} stretchContent>
				<RelativeContainer>
					<PdfBonoPosventaCard dineroHucha={huchaValues?.dineroHucha ?? ''} />

					<VouchersHuchaContainer className="voucher-hucha__container">
						<Container horizontalAlign={'center'} verticalAlign={'center'} padding={ContainerPadding.static350}>
							<Text
								appearance={TokenTextAppearance.headline300}
								color={TokenTextColor.inverted}
								textAlign={TextAlignment.center}
								bold
							>
								{huchaValues?.idUser}
							</Text>
						</Container>
					</VouchersHuchaContainer>
				</RelativeContainer>
			</Container>

			<Container
				padding={ContainerPadding.dynamic0100}
				wrap={'never'}
				gutter={ContainerGutter.static100}
				horizontalAlign={'center'}
				verticalAlign={'center'}
				shrinkContent
			>
				<Container
					padding={{
						right: ContainerPadding.static100,
					}}
				>
					<StatusIndicator status={VouchersHelper.getVoucherStatusColor(huchaValues.status)} />
				</Container>

				<Text appearance={TokenTextAppearance.copy200} color={TokenTextColor.primary}>
					{VouchersHelper.getValidityMessage(huchaValues.status, huchaValues.expirationDate, null)}
				</Text>
			</Container>

			<Container
				padding={{
					top: ContainerPadding.static250,
					bottom: ContainerPadding.static250,
					right: ContainerPadding.static500,
					left: ContainerPadding.static500,
				}}
				stretchContent
				wrap="always"
				verticalAlign="center"
				horizontalAlign="center"
			>
				<UserDataContainer
					wrap="always"
					verticalAlign="center"
					horizontalAlign="center"
					padding={{ bottom: ContainerPadding.static250, top: ContainerPadding.static250 }}
					stretchContent
				>
					<Text appearance={TokenTextAppearance.headline200} textAlign={TextAlignment.center}>
						Nombre: <b>{huchaValues?.name + ' ' + huchaValues?.apellido1 + ' ' + huchaValues?.apellido2}</b>
					</Text>

					<Text appearance={TokenTextAppearance.headline200} textAlign={TextAlignment.center}>
						E-mail: <b>{huchaValues?.email}</b>
					</Text>

					<Text appearance={TokenTextAppearance.headline200} textAlign={TextAlignment.center}>
						Importe del bono<Text sup>1</Text>: <b>{huchaValues?.dineroHucha}€</b>
					</Text>

					<Text appearance={TokenTextAppearance.headline200} textAlign={TextAlignment.center}>
						Fecha de descarga: <b>{huchaValues?.fechaDescarga}</b>
					</Text>
				</UserDataContainer>

				<Container
					padding={{
						top: ContainerPadding.static350,
					}}
					verticalAlign="center"
					horizontalAlign="center"
					wrap="always"
				>
					<Text appearance={TokenTextAppearance.copy200} textAlign={TextAlignment.center}>
						Este bono es solo válido para recambios, en operaciones con un importe mínimo de 100€ sin incluir la mano de
						obra.
					</Text>
					<Text appearance={TokenTextAppearance.copy200} textAlign={TextAlignment.center} bold>
						Es intransferible y está sujeto a las condiciones que se especifican a continuación.
					</Text>
				</Container>

				<Container
					wrap={'always'}
					padding={{
						top: ContainerPadding.dynamic0270,
					}}
					verticalAlign={'center'}
					horizontalAlign={'center'}
				>
					<BonoPosventaDisclaimerContent textGutter={ContainerGutter.static200} />
				</Container>
			</Container>
		</>
	);
};
